._1vsf4ct0 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid #1662C5;
  background: #1662C5;
  color: #FFFFFF;
}
._1vsf4ct0:hover {
  border: 1px solid #004493;
  background: #004493;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._1vsf4ct0:focus-visible {
  outline-offset: 2px !important;
  outline: 2px solid #1662C5 !important;
  transition: none;
}
._1vsf4ct0:active {
  border: 1px solid #002E69;
  background: #002E69;
  box-shadow: none;
}
._1vsf4ct0:disabled {
  border: 1px solid #C7C6CA;
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._1vsf4ct1 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FFFFFF;
  color: #1662C5;
  border: 1px solid #1662C5;
}
._1vsf4ct1:focus {
  color: #1662C5;
  background: #FFFFFF;
  border: 1px solid #1662C5 !important;
  transition: none;
}
._1vsf4ct1:active {
  color: #001A41;
  border: 1px solid #002E69 !important;
  background: #ADC6FF;
  box-shadow: none;
}
._1vsf4ct1:disabled {
  cursor: not-allowed !important;
  color: #C7C6CA;
  border: 1px solid #C7C6CA;
  background-color: #FFFFFF;
  box-shadow: none;
}
._1vsf4ct1:hover:not(:disabled) {
  border: 1px solid #002E69;
  color: #002E69;
  background: #D8E2FF !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._1vsf4ct2 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FFFFFF;
  color: #1662C5;
  border: 1px solid #FFFFFF;
  min-width: 25px;
}
._1vsf4ct2:focus {
  color: #1662C5;
  background: #FFFFFF;
  border: 1px solid white;
  transition: none;
}
._1vsf4ct2:active {
  color: #002E69;
  border: 1px solid #ADC6FF !important;
  background: #ADC6FF !important;
  box-shadow: none;
}
._1vsf4ct2:disabled {
  background: #FFFFFF;
  cursor: not-allowed;
  border: 1px solid #FFFFFF;
  color: #C7C6CA;
  box-shadow: none;
}
._1vsf4ct2:hover:not(:disabled) {
  color: #004493;
  background: #D8E2FF !important;
  border: 1px solid #D8E2FF !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._1vsf4ct3 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FFFFFF;
  color: #BA1A1A;
  border: 1px solid #FFFFFF;
  min-width: 25px;
}
._1vsf4ct3:focus {
  color: #BA1A1A;
  background: #FFFFFF;
  border: 1px solid white;
  transition: none;
}
._1vsf4ct3:active {
  color: #690004;
  border: 1px solid #FFB4AB !important;
  background: #FFB4AB !important;
  box-shadow: none;
}
._1vsf4ct3:disabled {
  background: #FFFFFF;
  cursor: not-allowed;
  border: 1px solid #FFFFFF;
  color: #C7C6CA;
  box-shadow: none;
}
._1vsf4ct3:hover:not(:disabled) {
  color: #930009;
  background: #FFDAD5 !important;
  border: 1px solid #FFDAD5 !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._1vsf4ct4 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #BA1A1A;
  color: #FFFFFF;
}
._1vsf4ct4:hover {
  background: #930009;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._1vsf4ct4:focus-visible {
  background: #BA1A1A;
  outline-offset: 2px !important;
  outline: 2px solid #BA1A1A !important;
  transition: none;
}
._1vsf4ct4:active {
  background: #690004;
  box-shadow: none;
}
._1vsf4ct4:disabled {
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._1vsf4ct5 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #EDF0FF;
  color: #1662C5;
}
._1vsf4ct5:hover {
  background: #D8E2FF !important;
}
._1vsf4ct5:focus {
  background: #FFFFFF;
  border: 1px solid white;
  transition: none;
}
._1vsf4ct5:active {
  border: none;
}
._1vsf4ct5:disabled {
  background: #FFFFFF;
  cursor: not-allowed;
  border: 1px solid #FFFFFF;
  color: #C7C6CA;
  box-shadow: none;
}
._1vsf4ct6 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FEE7EB;
  color: #BA1A1A;
}
._1vsf4ct6:hover {
  background: #FFDAD5 !important;
}
._1vsf4ct6:focus {
  background: #FFFFFF;
  border: 1px solid white;
  transition: none;
}
._1vsf4ct6:active {
  border: none;
}
._1vsf4ct6:disabled {
  background: #FFFFFF;
  cursor: not-allowed;
  border: 1px solid #FFFFFF;
  color: #C7C6CA;
  box-shadow: none;
}
._1vsf4ct7 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FFECC2;
  color: #815600;
}
._1vsf4ct7:hover {
  background: #FFD885 !important;
}
._1vsf4ct7:focus {
  background: #FFFFFF;
  border: 1px solid white;
  transition: none;
}
._1vsf4ct7:active {
  border: none;
}
._1vsf4ct7:disabled {
  background: #FFFFFF;
  cursor: not-allowed;
  border: 1px solid #FFFFFF;
  color: #C7C6CA;
  box-shadow: none;
}
._1vsf4ct8 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #CCFFE1;
  color: #006C47;
}
._1vsf4ct8:hover {
  background: #B0EFD0 !important;
}
._1vsf4ct8:focus {
  background: #FFFFFF;
  border: 1px solid white;
  transition: none;
}
._1vsf4ct8:active {
  border: none;
}
._1vsf4ct8:disabled {
  background: #FFFFFF;
  cursor: not-allowed;
  border: 1px solid #FFFFFF;
  color: #C7C6CA;
  box-shadow: none;
}
._1vsf4ct9 {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #D8E2FF;
  color: #001A41;
}
._1vsf4ct9:hover {
  background: #D8E2FF;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._1vsf4ct9:focus-visible {
  outline-offset: 2px !important;
  outline: 2px solid #1662C5 !important;
  transition: none;
}
._1vsf4ct9:disabled {
  border: 1px solid #C7C6CA;
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._1vsf4cta {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FFDAD5;
  color: #410002;
}
._1vsf4cta:hover {
  background: #FFDAD5;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._1vsf4cta:focus-visible {
  outline-offset: 2px !important;
  outline: 2px solid #BA1A1A !important;
  transition: none;
}
._1vsf4cta:disabled {
  border: 1px solid #C7C6CA;
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._1vsf4ctb {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #FFD885;
  color: #291800;
}
._1vsf4ctb:hover {
  background: #FFD885;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._1vsf4ctb:focus-visible {
  outline-offset: 2px !important;
  outline: 2px solid #815600 !important;
  transition: none;
}
._1vsf4ctb:disabled {
  border: 1px solid #C7C6CA;
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._1vsf4ctc {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #B0EFD0;
  color: #002113;
}
._1vsf4ctc:hover {
  background: #B0EFD0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._1vsf4ctc:focus-visible {
  outline-offset: 2px !important;
  outline: 2px solid #006C47 !important;
  transition: none;
}
._1vsf4ctc:disabled {
  border: 1px solid #C7C6CA;
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._1vsf4ctd {
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  background: linear-gradient(90deg, #1662C5, #2DBAD7);
  color: var(--f4wedf1u);
}
._1vsf4ctd:hover {
  background: linear-gradient(90deg, #004493, #009FB9);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._1vsf4ctd:focus-visible {
  background: linear-gradient(90deg, #1662C5, #2DBAD7);
  outline-offset: 2px !important;
  outline: 2px solid #1662C5 !important;
  transition: none;
}
._1vsf4ctd:active {
  background: linear-gradient(90deg, #002E69, #008399);
  box-shadow: none;
}
._1vsf4ctd:disabled {
  background: #C7C6CA;
  cursor: not-allowed;
  box-shadow: none;
}
._1vsf4cte {
  --quiet-bg: transparent;
  --quiet-fg: #1f2937;
  --quiet-border: transparent;
  --quiet-hover-bg: #f3f4f6;
  --quiet-hover-fg: #111827;
  --quiet-active-bg: #e5e7eb;
  --quiet-active-fg: #111827;
  --quiet-focus: #60a5fa;
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  padding: 6px 12px;
  text-align: center;
  white-space: nowrap;
  transition: .3s;
  font-size: 12px;
  min-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--quiet-bg);
  color: var(--quiet-fg);
  border: 1px solid var(--quiet-border);
}
._1vsf4cte:hover {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
._1vsf4cte:active {
  box-shadow: none;
}
._1vsf4cte:disabled {
  cursor: not-allowed;
  box-shadow: none;
}
._1vsf4cte[hidden] {
  display: none;
}
._1vsf4cte:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
._1vsf4cte:not(:disabled) {
  cursor: pointer;
}
._1vsf4cte:focus-visible {
  outline: 2px solid var(--quiet-focus);
  outline-offset: 2px;
}
._1vsf4cte:not(:disabled):hover {
  background: var(--quiet-hover-bg);
  color: var(--quiet-hover-fg);
}
._1vsf4cte:not(:disabled):active {
  background: var(--quiet-active-bg);
  color: var(--quiet-active-fg);
}
html.theme-dark ._1vsf4cte {
  --quiet-bg: transparent;
  --quiet-fg: #e5e7eb;
  --quiet-border: transparent;
  --quiet-hover-bg: rgba(255, 255, 255, 0.08);
  --quiet-hover-fg: #ffffff;
  --quiet-active-bg: rgba(255, 255, 255, 0.12);
  --quiet-active-fg: #ffffff;
  --quiet-focus: #93c5fd;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4cte:disabled {
  background: transparent;
  color: #5E5E62;
  opacity: 1;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct0 {
  border: 1px solid #80ABFF;
  background: #80ABFF;
  color: #1B1B1F;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct0:hover {
  border: 1px solid #4B8EFF;
  background: #4B8EFF;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct0:focus-visible {
  outline: 2px solid #4B8EFF !important;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct0:active {
  color: #ADC6FF;
  border: 1px solid transparent;
  background: #002E69;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct0:disabled {
  color: #919094;
  background: #46464A;
  border: 1px solid #46464A;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct1 {
  background: transparent;
  color: #ADC6FF;
  border: 1px solid #80ABFF;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct1:focus-visible {
  color: #ADC6FF;
  background: transparent;
  border: 1px solid #80ABFF !important;
  outline: 1px solid #80ABFF !important;
  outline-offset: 1px !important;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct1:active {
  border: 1px solid #80ABFF;
  background: #80ABFF;
  color: #1B1B1F;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct1:disabled {
  color: #5E5E62;
  border: 1px solid #46464A;
  background-color: transparent;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct1:hover:not(:disabled) {
  border: 1px solid #ADC6FF;
  color: #D8E2FF;
  background: rgba(255, 255, 255, 0.08) !important;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct2 {
  background: transparent;
  color: #ADC6FF;
  border: 1px solid transparent;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct2:focus-visible {
  color: #ADC6FF !important;
  background: transparent !important;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct2:active {
  border: 1px solid #80ABFF !important;
  background: #80ABFF !important;
  color: #1B1B1F;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct2:disabled {
  background: transparent;
  color: #5E5E62;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct2:hover:not(:disabled) {
  color: #ADC6FF;
  background: rgba(255, 255, 255, 0.08) !important;
  border: 1px solid transparent !important;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct4 {
  color: #930009;
  background: #FF897D;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct4:hover {
  color: #930009;
  background: #FB6156;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct4:focus-visible {
  color: #930009;
  background: #FF897D;
  outline: 2px solid #FF897D !important;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct4:active {
  color: #FF897D;
  background: #690004;
  border: 1px solid transparent;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct4:disabled {
  color: #919094;
  background: #46464A;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct3 {
  background: transparent;
  color: #FFB4AB;
  border: 1px solid transparent;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct3:focus {
  color: #FFB4AB;
  background: transparent;
  border: 1px solid #FF897D !important;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct3:active {
  color: #FF897D !important;
  background: #690004 !important;
  border: 1px solid transparent !important;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct3:disabled {
  background: transparent;
  color: #5E5E62;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ct3:hover:not(:disabled) {
  color: #FF897D;
  background: #410002 !important;
  border: 1px solid #410002 !important;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ctd {
  background: linear-gradient(90deg, #4B8EFF, #55D6F4);
  color: #1B1B1F;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ctd:hover {
  background: linear-gradient(90deg, #1E73E8, #2DBAD7);
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ctd:focus-visible {
  background: linear-gradient(90deg, #4B8EFF, #55D6F4);
  outline: 2px solid #4B8EFF !important;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ctd:active {
  background: linear-gradient(90deg, #002E69, #004E5C);
  border: none;
}
html.theme-dark.button-dark-mode-enabled ._1vsf4ctd:disabled {
  color: #919094;
  background: #46464A;
}